export default {
  title: 'Zawodnik',
  type: 'object',
  properties: {
    profile: {
      title: 'Profil',
      type: 'object',
      properties: {
        lang: {
          title: 'schema.profile.lang',
          type: 'string',
          fieldRequired: true
        },
        firstName: {
          title: 'schema.profile.firstName',
          type: 'string',
          fieldRequired: true
        },
        lastName: {
          title: 'schema.profile.lastName',
          type: 'string',
          fieldRequired: true
        },
        phoneNumber: {
          title: 'schema.profile.phoneNumber',
          type: 'string',
          format: 'string',
          fieldRequired: false
        },
        birthDate: {
          title: 'schema.profile.birthDate',
          type: 'string',
          format: 'date',
          fieldRequired: true
        }
      }
    },
    teamId: {
      type: 'number',
      fieldRequired: true
    }
  }
};
